import * as React from 'react';
import styles from 'containers/Layouts/Layout.module.css';
import Fab from '@mui/material/Fab';
import UpIcon from '@mui/icons-material/KeyboardArrowUp';
import i18n from 'i18n/I18nInstance';
import _ from 'classnames';

const PIXELS_FROM_TOP = 20;

// This component display a button that returns the scroll to top.
// This button is hidden by default and is displayed until the user scrolls 20 px or more.
// The component could be added in any container because it has a fixed position at the bottom right corner.
export default class Back2Top extends React.Component {
    state = {
        showBack2Top: false,
    };

    scrollToTop = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };

    onScroll = () => {
        if (
            document.body.scrollTop > PIXELS_FROM_TOP ||
            document.documentElement.scrollTop > PIXELS_FROM_TOP
        ) {
            this.setState({ showBack2Top: true });
        } else {
            this.setState({ showBack2Top: false });
        }
    };

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        this.onScroll();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    }

    render() {
        const i18n_backTop = i18n.translator.formatMessage({
            id: 'back2Top.GoTop',
            defaultMessage: 'Go to top of page',
        });
        return (
            <React.Fragment>
                <div
                    data-qaid="back2Top"
                    className={_(styles.back2top, styles.noPrint)}
                    style={{ display: this.state.showBack2Top ? 'block' : 'none' }}
                    onClick={() => this.scrollToTop()}
                >
                    <Fab data-qaid="back2TopComponent" aria-label={i18n_backTop} color="secondary">
                        <UpIcon />
                    </Fab>
                </div>
            </React.Fragment>
        );
    }
}
